var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-details view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c(
        "div",
        {
          staticClass: "errorMessage",
          class: {
            "errorMessage-visible":
              _vm.errorPropery ||
              _vm.errorResident ||
              _vm.errorAge ||
              _vm.errorAddress ||
              _vm.errorPostCodeNotFound ||
              _vm.errorSinisterNotFOund,
          },
        },
        [
          _c(
            "div",
            { staticClass: "errorMessage-container" },
            [
              _c("svgicon", {
                attrs: {
                  icon: "alert-circle",
                  height: "24",
                  width: "24",
                  color: "#EC513A",
                },
              }),
              _c("p", { staticClass: "text-medium redVidid mg mg--l-2" }, [
                _vm._v(_vm._s(_vm.errorMsgGeneral)),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("claim.details.title")))]),
        _c(
          "div",
          { staticClass: "view_form" },
          [
            _c("ma-input-text", {
              attrs: {
                value: _vm.stateComWarrantyAddress,
                type: "text",
                name: "propsAddress",
                col: "4",
                icon: "ico-cp",
                literal: _vm.$t("claim.details.address.literal"),
                inputError: _vm.errorAddress,
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyAddress = $event
                },
              },
            }),
            _c("ma-input-text", {
              staticClass: "zipCodeInput",
              attrs: {
                value: _vm.stateWarrantyZipCode,
                type: "text",
                name: "propsZipCode",
                col: "4",
                icon: "ico-cp",
                literal: _vm.$t("claim.details.zipCode.literal"),
                disabled: "",
                inputError: _vm.errorPostCodeNotFound,
                inputTextError: this.$t(`notifications.error.0.title`),
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyZipCode = $event
                },
              },
            }),
            _c(
              "div",
              { staticClass: "map mg mg--b-5 mg--t-2" },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showStreetView,
                        expression: "showStreetView",
                      },
                    ],
                    attrs: { id: "warrantyProps_street-view" },
                  }),
                ]),
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showStreetView,
                          expression: "!showStreetView",
                        },
                      ],
                      staticClass: "warrantyProps__image",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "warrantyProps__placeholder" },
                        [
                          _c("svgicon", {
                            attrs: { icon: "fence", height: "78", width: "78" },
                          }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-medium mg mg--b-1 mg--t-6 black",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("claim.details.map.empty.title"))
                              ),
                            ]
                          ),
                          _c("p", { staticClass: "text-small black" }, [
                            _vm._v(
                              _vm._s(_vm.$t("claim.details.map.empty.text"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c("ma-input-textarea", {
              staticClass: "mg mg--b-4",
              attrs: {
                value: _vm.stateWarrantyObservations,
                type: "textarea",
                name: "textarea",
                col: "4",
                literal: _vm.$t("claim.details.observations.literal"),
                placeholderTxt: _vm.$t("claim.details.textArea.placeHolder"),
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyObservations = $event
                },
              },
            }),
            _c("ma-input-btn", {
              attrs: {
                "qa-property-type-list": "",
                value: _vm.stateWarrantyPropertyType,
                type: "btn",
                name: "propsPropertyType",
                col: "2",
                options: _vm.propertyTypeOptions,
                literal: _vm.$t("claim.details.propertyType.literal"),
                inputError: _vm.errorPropery,
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyPropertyType = $event
                },
              },
            }),
            _c("ma-input-btn", {
              attrs: {
                value: _vm.stateWarrantyMoreThanTwoYears,
                type: "btn",
                name: "moreThanTwoYears",
                col: "2",
                options: _vm.moreThanTwoYearsOptions,
                literal: _vm.$t("claim.details.moreThanTwoYears.literal"),
                disabled: "",
                inputError: _vm.errorAge,
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyMoreThanTwoYears = $event
                },
              },
            }),
            _c("ma-input-btn", {
              attrs: {
                value: _vm.stateWarrantyResidentType,
                type: "btn",
                name: _vm.$t("claim.details.residentType.name"),
                col: "2",
                options: _vm.residentTypeOptions,
                literal: _vm.$t("claim.details.residentType.literal"),
                disabled: "",
                inputError: _vm.errorResident,
              },
              on: {
                change: function ($event) {
                  _vm.stateComWarrantyResidentType = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c("ma-confrim-btn", {
          attrs: {
            handleButtonClick: _vm.handleConfirmInfo,
            title: _vm.$t("actions.confirmAndContinue"),
            btnType: "functionalBtn",
            "qa-claimDetails-button": "",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }